<script setup lang="ts">
import FooterLinksList from '@/components/Footer/footer-links/FooterLinksList.vue'

const INFORMATION_LINKS = [
  {
    title: 'Политика конфиденциальности',
    path: '/confidential/',
  },
  {
    title: 'Пользовательское соглашение',
    path: '/terms_of_use/',
  },
  {
    title: 'Для потребителей',
    path: '/important/',
  },
  {
    title: 'Правила продажи',
    path: '/rules/',
  },
]
</script>

<template>
  <footer-links-list :links="INFORMATION_LINKS" />
</template>
